import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import Swal from 'sweetalert2';
import { EstadoFormularioSituacion } from 'src/app/models/enum/estado-formulario-situacion.enum';

@Component({
  selector: 'app-nueva-solicitud-credito',
  templateUrl: './nueva-solicitud-credito.component.html',
  styleUrls: ['./nueva-solicitud-credito.component.css']
})
export class NuevaSolicitudCreditoComponent implements OnInit {
  solicitudForm: FormGroup;
  isEditMode: boolean = false;
  solicitudGuid: string | any;
  userId: any;
  constructor(private fb: FormBuilder, private dataService: DataService, private router: Router,
    private rutaActiva: ActivatedRoute, private auth: AuthService) {
      this.auth.user$.subscribe({
        next: (user) => {
          if (user && user['user_metadata']) {
            this.userId = user['user_metadata'].guid_credipal;
            this.validaEstadoSituacionFirmado();
          }
        },
        error: (e) => console.log(e)
      });
      this.solicitudForm = this.fb.group({
        guid: (null),
        monto: [null, [Validators.required, Validators.min(1000)]],
        duracion: [null, [Validators.required, Validators.min(1), Validators.max(120)]],
        fechaSolicitud: [{ value: new Date(), disabled: true }, Validators.required],
        fechaTermino:(null)
      });

  }

  ngOnInit() {
    this.solicitudGuid = this.rutaActiva.snapshot.params['guid'];
    if (this.solicitudGuid) {
      this.isEditMode = true;
      this.dataService.getData('solicitud-credito/' + this.solicitudGuid).subscribe({
        next: (v) => {
          this.solicitudForm.patchValue({
            guid: this.solicitudGuid,
            monto: v.monto,
            duracion: v.duracion,
            fechaSolicitud: v.fechaSolicitud
          });
        }
      })
    } else {
      this.solicitudForm.patchValue({
        fechaSolicitud: new Date()
      });
    }
  }

  onSubmit() {
    if (this.solicitudForm.valid) {
      this.removeNullGuid();
      var url = this.isEditMode ? `solicitud-credito/${this.solicitudGuid}` : "solicitud-credito";
      const solicitud = this.solicitudForm.getRawValue();
      const fechaTermino = new Date(solicitud.fechaSolicitud);
      fechaTermino.setDate(fechaTermino.getDate() + 5);
      solicitud.fechaTermino = fechaTermino;
      if(this.isEditMode){
        this.dataService.updateData(solicitud, url).subscribe({
          next: (v) => {
            this.router.navigate(['/home']);
          },
          error: (e) => {
            console.log(e);
          }
        });
      }else{
        this.dataService.postData(solicitud, url).subscribe({
          next: (v) => {
            this.router.navigate(['/home']);
          },
          error: (e) => {
            console.log(e);
          }
        });
      }
    }
  }

  validaEstadoSituacionFirmado(){
      if (this.userId) {
        const endpoint = `persona/${this.userId}`;
        this.dataService.getData(endpoint).subscribe({
          next: (v) => {
            if(v.estadoSituacion.estadoFormularioSituacion != 'Firmado'){
              Swal.fire({
                title: 'Antes de continuar!',
                text: 'Por favor, primero debemos completar el estado de situacion antes de continuar.!!',
                icon: 'info',
                confirmButtonText: 'OK',
              }).then(() => {
                this.router.navigate(['estado-situacion']);
              });
            }else{
              Swal.close();
            }
          },
          error: (e) => console.error(e)
      });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se ha podido obtener el perfil del usuario',
          showConfirmButton: false,
        })
      }
  }

  removeNullGuid() {
      if(this.solicitudForm.get('guid')?.value == null) {
        this.solicitudForm.removeControl('guid');
      }
  }
}
